import styled from 'styled-components'
import { ContentWidth } from '@ta-interaktiv/react-disco-grid'
import { GlobalVariables } from 'Globals/GlobalVariables'
import { useEffect, useRef, useState } from 'react'
import sheetrock from 'sheetrock'
import { zip } from 'd3-array'
import { categories } from 'global/categories'
import { textToClassName } from 'global/textToClassName'
import { HotelCategory } from 'components/hotelCategory'
import { Provider } from 'react-redux'
import store from 'store/store'
import colorVariables from '../../Globals/colors.module.css'
import fontVariables from '../../Globals/fonts.module.css'
import './styles.scss'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/table.css'
const MainComponent = ({
  tenant,
  colorMode,
  properties,
}: MicroFrontendProps) => {
  const [requestStatus, setRequestStatus] = useState<
    'loading' | 'error' | 'ready'
  >('loading')
  const [hotelsByCategory, setHotelsByCategory] =
    useState<Map<string, Map<string, any>[]>>()
  const hiddenElementRef = useRef<HTMLDivElement>(null)
  const ratingExplanationStyles = {
    h3: (props: any) => (
      <h3 className='ui tiny infographic dividing header' {...props} />
    ),
    ul: (props: any) => <div className='ui infographic icon list' {...props} />,
    li: (props: any) => (
      <div className='item'>
        <i className='right caret icon' />
        <div className='content' {...props} />
      </div>
    ),
  }
  /**
   * Prepare the hotel data and set the state once its ready
   * @param error
   * @param options
   * @param response
   */
  const prepareData = (
    error: Error,
    options: any,
    response: SheetrockResponse
  ) => {
    // Error handling
    if (error) {
      console.group('Main Component 🗂 Sheetrock Loader')
      console.log(error)
      console.groupEnd()
      setRequestStatus('error')
      return
    }

    const mapRows = response.rows.map((row) => {
      const pairs = zip(row.labels, row.cellsArray) as [string, string][]
      return new Map(pairs)
    })

    // Check that we actually have data
    console.assert(mapRows[1].get('Kategorie') === 'Ferien')

    // Create a new map
    const hotelsByCategory: Map<string, Map<string, any>[]> = new Map()

    // Get the categories in the configuration and pull all the hotels for
    // each category out of the list
    Object.keys(categories).forEach((category) => {
      hotelsByCategory.set(
        category,
        mapRows.filter((hotel) => hotel.get('Kategorie') === category)
      )
    })

    setHotelsByCategory(hotelsByCategory)
    setRequestStatus('ready')
  }
  useEffect(() => {
    if (hiddenElementRef) {
      sheetrock({
        url: 'https://docs.google.com/spreadsheets/d/1ZmF-PYUgu4OQMRF3tPfwQnfugasvf90Qbemu0iqL90E/edit#gid=787655047',
        query: 'select A,B,C,D,E,F,G,H,I,J,K,L,M,N,O,P where A != ""',
        target: hiddenElementRef.current,
        callback: prepareData,
      })
    }
  }, [hiddenElementRef.current])

  const globalClasses = [
    colorVariables.globalColors,
    fontVariables.globalFonts,
    colorMode === 'dark' ? colorVariables.globalColorsDark : '',
  ]

  return (
    <Provider store={store}>
      <AppContainer
        colorMode={colorMode}
        className={globalClasses.join(' ') + ' index'}
      >
        <HiddenElement ref={hiddenElementRef} />
        
        <Wrapper>
          <ContentWidth>
            <>
              {hotelsByCategory &&
                Object.keys(categories).map((category: string) => (
                  <HotelCategory
                    key={textToClassName(category)}
                    category={category}
                    id={`cat-${textToClassName(category)}`}
                    hotelList={hotelsByCategory.get(category) || []}
                    request={requestStatus}
                  />
                ))}
            </>
          </ContentWidth>
        </Wrapper>
      </AppContainer>
    </Provider>
  )
}
const AppContainer = styled(GlobalVariables)`
  font-family: var(--font-plex);
  font-size: 1.8rem;
  line-height: 3rem;
`
const HiddenElement = styled.div`
  display: none;
`
const Wrapper = styled.div`
  background-color: var(--gray-6);
`
export default MainComponent
